import { RequestedProblem } from "../types/Problem";

export const userData = {
	requested_problems: null,
	submissions: null,
};
